import { useMemo } from "react";
import { CheckCircle2 } from "lucide-react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { useLanguage } from "@/context/LanguageContext";
import { ordersLabels } from "@/i18n";

interface ContractSignatureSuccessDialogProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  description?: string;
}

export const ContractSignatureSuccessDialog = ({
  isOpen,
  onClose,
  title: titleOverride,
  description: descriptionOverride,
}: ContractSignatureSuccessDialogProps) => {
  const { language } = useLanguage();
  const o = useMemo(() => ordersLabels(language), [language]);
  const title = titleOverride ?? o.signatureSuccess?.title ?? "Signering klar";
  const description =
    descriptionOverride ??
    o.signatureSuccess?.description ??
    "Kontraktet har uppdaterats. Du kan se statusen i din orderlista.";

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[420px] border-none bg-transparent shadow-none">
        <div className="flex flex-col items-center justify-center py-12 space-y-6 bg-white dark:bg-gray-900 rounded-lg">
          <div className="relative">
            <CheckCircle2 className="h-24 w-24 text-green-500 animate-in zoom-in duration-500" />
            <div className="absolute inset-0 bg-green-500 rounded-full animate-ping opacity-30" />
            <div className="absolute inset-0 bg-green-500/20 rounded-full animate-pulse" />
          </div>
          <div className="text-center space-y-2">
            <p className="text-2xl font-bold text-green-600 dark:text-green-400 animate-in fade-in duration-500">
              {title}
            </p>
            <p className="text-sm text-gray-600 dark:text-gray-400 animate-in fade-in duration-700">
              {description}
            </p>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

